import React, {Component} from "react"
import Moment from 'moment'
import {_getUserSearchHistory} from "../../../../../../services/apis/AdminServices"

class SearchHistory extends Component {
    state = {
        searchHistory: [],
        error: ''
    }

    componentDidMount() {
        this._fetchSearchHistory()
    }

    _fetchSearchHistory = () => {
        const {userId} = this.props

        _getUserSearchHistory(userId)
            .then(result => {
                const {success, data, message} = result

                if (success) {
                    this.setState({
                        searchHistory: data,
                        error: ''
                    })
                } else {
                    this.setState({
                        error: message
                    })
                }
            }).catch(err => {
            this.setState({
                error: err.message
            })
        })
    }

    render() {
        const {searchHistory, error} = this.state

        if (!!error) {
            return (
                <div className="SearchHistoryError">{error}</div>
            )
        }

        return (
            <div className="SearchHistory">
                <table>
                    <thead>
                    <tr>
                        <th className="Date">Date</th>
                        <th className="Type">Type</th>
                        <th className="Field">Field</th>
                        <th className="Term">Term</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        searchHistory.map((search, index) => {
                            const {created, field, term, type} = search
                            const timeHistoryFormat = Moment(created).format('DD/MM/YYYY, hh:mm:ss A')

                            return (
                                <tr key={index}>
                                    <td className="Date">
                                        <span>{timeHistoryFormat}</span>
                                    </td>
                                    <td className="Type">{type}</td>
                                    <td className="Field">{field}</td>
                                    <td className="Term">{term}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

SearchHistory.propTypes = {}

export default SearchHistory



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserPage/components/SearchHistory.js